import React from "react";
import { TbExternalLink, TbLoader } from "react-icons/tb";
import { useCheckout } from "~/hooks/useCheckout";

interface KiwifyCheckoutButtonProps {
	planId?: string;
	extensionId?: string;
}

export function KiwifyCheckoutButton({
	planId,
	extensionId,
}: KiwifyCheckoutButtonProps) {
	const { initiatePayment, isRedirecting } = useCheckout();

	return (
		<div className="flex flex-col items-center justify-center p-6 gap-4">
			<p className="text-gray-600 text-center mb-2">
				Você será redirecionado para o ambiente seguro da Kiwify para concluir o
				pagamento.
			</p>
			<button
				type="button"
				disabled={isRedirecting}
				onClick={() => initiatePayment({ planId, extensionId })}
				className="flex items-center gap-2 px-8 py-3 bg-gpa-blue-500 text-white rounded-md font-semibold hover:bg-gpa-blue-600 transition-colors disabled:opacity-50"
			>
				{isRedirecting ? (
					<>
						<TbLoader className="animate-spin" size={20} />
						Redirecionando...
					</>
				) : (
					<>
						Ir para o Pagamento
						<TbExternalLink size={20} />
					</>
				)}
			</button>
		</div>
	);
}
